var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceAndTechnologyQRcode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3880.000000, -1241.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device-and-technology/QRcode",
    transform: "translate(3880.000000, 1241.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,17.5 L14.5,31.5 L3.5,31.5 C1.846,31.5 0.5,30.154 0.5,28.5 L0.5,28.5 L0.5,17.5 L14.5,17.5 Z M20.5,23.5 L20.5,26.5 L23.5,26.5 L23.5,29.5 L17.5,29.5 L17.5,23.5 L20.5,23.5 Z M29.5,23.5 L29.5,29.5 L26.5,29.5 L26.5,26.5 L23.5,26.5 L23.5,23.5 L29.5,23.5 Z M11.5,20.5 L3.5,20.5 L3.5,28.5 L11.5,28.5 L11.5,20.5 Z M9,23 L9,26 L6,26 L6,23 L9,23 Z M23.5,20.5 L23.5,23.5 L20.5,23.5 L20.5,20.5 L23.5,20.5 Z M20.5,17.5 L20.5,20.5 L17.5,20.5 L17.5,17.5 L20.5,17.5 Z M29.5,17.5 L29.5,20.5 L23.5,20.5 L23.5,17.5 L29.5,17.5 Z M14.5,0.5 L14.5,14.5 L0.5,14.5 L0.5,3.5 C0.5,1.846 1.846,0.5 3.5,0.5 L3.5,0.5 L14.5,0.5 Z M28.5,0.5 C30.154,0.5 31.5,1.846 31.5,3.5 L31.5,3.5 L31.5,14.5 L17.5,14.5 L17.5,0.5 Z M11.5,3.5 L3.5,3.5 L3.5,11.5 L11.5,11.5 L11.5,3.5 Z M28.5,3.5 L20.5,3.5 L20.5,11.5 L28.5,11.5 L28.5,3.5 Z M9,6 L9,9 L6,9 L6,6 L9,6 Z M26,6 L26,9 L23,9 L23,6 L26,6 Z",
    id: 135
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAndTechnologyQRcode);
export default __webpack_public_path__ + "static/media/device-and-technology-q-rcode.f38eb11d.svg";
export { ForwardRef as ReactComponent };